<script>
import baseEdit from '@/views/components/base/baseEdit.vue'
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: 'smsLog',
      key: 'id',
      url: {
        get: '/admin/system/developLog',
        add: '/admin/system/developLog',
        edit: '/admin/system/developLog',
      },
      items: [
        { label: '基本信息', desc: '表单的基本信息', type: 'header' },
        { label: '更新内容', name: 'content', value: '', type: 'textarea',width:'400px', rules: [{ required: true, trigger: 'blur' }] },
        { label: '版本号', name: 'version', value: '', type: 'input',width:'400px', rules: [{ required: true, trigger: 'blur' }] },
      ],
      forms: {},
    }
  },
  created() {
  },
  methods: {
  
  },
}
</script>
